/**
 * Processos do Override de Ficha Técnica.
 * Subcoleção: org/{orgId}/technical-sheet-override/{overrideId}/process
 */
export const TECHNICAL_SHEET_OVERRIDE_PROCESS = 'TechnicalSheetOverrideProcess';
export const OverrideProcessActionValues = [
    'ADD',
    'REMOVE',
    'UPDATE',
];
//# sourceMappingURL=technical-sheet-override-process.js.map